export const translations = {
  ht: {
    welcome: "Byenveni",
    agent_area_sub: "Espas ajan Takara Global Services",
    admin_area_sub: "Vwè tout aktivite Takara Global Services",
    // Common
    app_name: "Takara Global Services",
    app_tag: "Jesyon Transfè Zelle",
    tracking: "Swiv Transfè",
    admin: "Admin",
    agent: "Ajan",
    login: "Konekte",
    logout: "Dekonekte",
    dashboard: "Dashboard",
    agents: "Ajan yo",
    transfers: "Transfè yo",
    withdrawals: "Retrè yo",
    settings: "Paramèt",
    save: "Sove",
    cancel: "Anile",
    delete: "Efase",
    edit: "Modifye",
    create: "Kreye",
    confirm: "Konfime",
    search: "Chèche...",
    loading: "Ap chaje...",
    // Tracking
    track_title: "Swiv Transfè Zelle Ou",
    track_subtitle: "Antre No# Transfè ou a (fòma TG12345678) pou wè estati a",
    track_placeholder: "TG12345678",
    track_btn: "Verifye Estati",
    track_not_found: "Transfè pa jwenn",
    // Statuses
    status_pending: "An Atant",
    status_processing: "An Tretman",
    status_delivered: "Livre",
    status_canceled: "Anile",
    // Admin login
    admin_login_title: "Koneksyon Admin",
    email: "Imèl",
    password: "Modpas",
    // Admin dashboard
    total_agents: "Total Ajan",
    total_transfers: "Total Transfè",
    delivered: "Livre",
    pending: "An Atant",
    total_amount: "Montan Total",
    system_profit: "Pwofi Sistèm",
    agent_profit_owed: "Pwofi Ajan yo",
    pending_withdrawals: "Retrè An Atant",
    completed_withdrawals: "Retrè Fini",
    activity_7d: "Aktivite 7 dènye jou yo",
    // Agents
    add_agent: "Ajoute Ajan",
    name: "Non",
    phone: "Telefòn",
    address: "Adrès",
    cin: "CIN",
    nif: "NIF",
    telegram_chat_id: "Telegram Chat ID",
    profit: "Pwofi",
    percent: "Pousantaj (%)",
    fixed: "Fiks ($)",
    withdrawal_method: "Metòd Retrè",
    active: "Aktif",
    inactive: "Dezaktive",
    // Transfers
    new_transfer: "Nouvo Transfè",
    client_name: "Non Kliyan",
    client_phone: "Telefòn Kliyan",
    amount: "Montan",
    reference: "Referans",
    notes: "Nòt",
    assign_to_agent: "Bay Ajan",
    // Agent
    agent_login_title: "Espas Ajan",
    agent_login_sub: "Antre nimewo telefòn ou pou aksede",
    process_delivery: "Trete Livrezon",
    confirm_delivery: "Konfime Livrezon",
    cin_or_nif: "CIN oswa NIF benefisyè",
    cin_or_nif_hint: "Yon sèl chan — CIN oswa NIF.",
    search_transfer_ph: "Chèche pa No# Transfè (egz. TG12345678)…",
    tap_row_to_treat: "Tape yon ran pou trete livrezon an — pa bezwen glise.",
    no_transfer_match: "Pa gen transfè ki matche rechèch la",
    id_photo_required: "Obligatwa — foto CIN/NIF benefisyè a (JPG/PNG).",
    profit_total: "Pwofi Total",
    profit_withdrawn: "Pwofi Retire",
    profit_remaining: "Pwofi Ki Rete",
    request_withdrawal: "Mande Retrè",
    // Zelle
    zelle_info: "Kont Zelle",
    zelle_info_sub: "Non + nimewo oswa email Zelle. WhatsApp se pou asistans sou sit la.",
    zelle_account_name: "Non",
    zelle_handle: "Nimewo oswa email Zelle",
    zelle_handle_ph: "egz. +1305… oswa email@zelle.com",
    zelle_handle_hint: "Mete youn sèlman: nimewo telefòn Zelle a, oswa email Zelle a.",
    account_name: "Non Kont",
    account_email: "Imèl Kont",
    account_phone: "Telefòn Kont",
    zelle_whatsapp: "WhatsApp asistans",
    zelle_whatsapp_hint: "Nimewo pou bouton Asistans WhatsApp sou sit la (egz. +509…).",
    wa_assist: "Asistans WhatsApp",
    wa_assist_message: "Bonjou, m bezwen asistans sou yon transfè Takara Global Services (TGS).",
    forgot_password: "Bliye modpas?",
    forgot_password_title: "Rekipere modpas",
    forgot_password_sub: "Antre imèl admin ou — n ap voye yon lyen pou chanje modpas la.",
    forgot_password_send: "Voye lyen",
    reset_password_title: "Nouvo modpas",
    reset_password_sub: "Chwazi yon nouvo modpas (omwen 8 karaktè).",
    new_password: "Nouvo modpas",
    confirm_password: "Konfime modpas",
    save_password: "Sove modpas",
    change_password_title: "Modpas admin",
    change_password_sub: "Modpas la sove nan MongoDB — li pa chanje lè backend redeploy.",
    current_password: "Modpas aktyèl",
    back_to_login: "Retounen nan koneksyon",
    instructions: "Enstriksyon",
    // Withdrawals
    approve: "Apwouve",
    reject: "Rejte",
    mark_paid: "Make Peye",
    natcash_number: "Nimewo NatCash",
    natcash_name: "Non sou NatCash",
    // Dashboards
    welcome: "Byenveni",
    agent_area_sub: "Espas ajan Takara Global Services",
    admin_area_sub: "Vwè tout aktivite Takara Global Services",
    // Settings
    service_fee: "Frè Sèvis (%)",
    telegram_bot_token: "Telegram Bot Token",
    // Agent funding / cash
    fund_agent: "Bay Lajan",
    add_funding: "Ajoute Lajan",
    funding_amount: "Montan Lajan",
    funding_history: "Istwa Lajan Bay",
    total_funded: "Kòb Resevwa",
    cash_delivered: "Kòb Livre",
    cash_in_hand: "Balans",
    no_funding: "Poko gen lajan bay",
    funding_note: "Nòt (opsyonèl)",
    // Home / landing (accueil)
    hero_badge: "Zelle · Sekirize · Rapid",
    hero_title: "Voye lajan {{brand}} san tèt chaje.",
    hero_subtitle: "Takara Global Services konekte dyaspora ayisyen an ak fanmi yo an peyi Dayiti — transfè Zelle konfyab ki livre nan kèk minit atravè rezo ajan lokal nou an.",
    track_example: "Egzanp:",
    trust_same_day: "Konfimasyon menm jou",
    trust_secure: "100% Sekirize",
    trust_network: "Rezo Nasyonal",
    stat_delivery: "Livrezon",
    stat_flat_fee: "Frè fiks",
    stat_local: "Lokal",
    result_transfer_id: "No# Transfè",
    result_created_at: "Dat kreyasyon",
    result_delivered_at: "Livre nan",
    result_cancel_reason: "Rezon anilasyon",
    result_cancel_solution: "Solisyon",
    cancel_solution_refund: "Nou ap prepare ranbousman lajan an. Ekip TGS ap kontakte w si yo bezwen plis detay.",
    cancel_solution_reactivate: "Transfè a pral re-aktive. Benefisyè a ap kapab pase pran lajan an lè pwoblèm nan rezoud.",
    result_reactivated: "Re-aktive",
    family_badge: "Fanmi Kontan",
    family_title: "Chak dola ki rive, se yon souri.",
    family_subtitle: "Lajan ou voye a rive dirèkteman nan men fanmi w — an sekirite, an bon eta, ak kè kontan.",
    family_img_alt: "Fanmi kontan k ap kenbe dola ameriken nan men yo",
    why_eyebrow: "Poukisa TGS",
    why_title: "Yon sèl platfòm. Tout sa ou bezwen.",
    feat_fast_title: "Ultra rapid",
    feat_fast_desc: "Konfimasyon nan minit sèlman apre reseptè a resevwa lajan an.",
    feat_secure_title: "Sekirize",
    feat_secure_desc: "Enfrastrikti bank-grade epi tokenizasyon pou pwoteje enfòmasyon w.",
    feat_agents_title: "Rezo Ajan",
    feat_agents_desc: "Ajan lokal fyab ki byen fòme atravè tout peyi a.",
    feat_realtime_title: "Rapò Tan Reyèl",
    feat_realtime_desc: "Swiv tout tranzaksyon w yo — tout enfòmasyon nan yon sèl paj.",
    how_eyebrow: "Kijan sa mache",
    how_title: "3 etap senp sèlman",
    how_step1_title: "Voye Zelle",
    how_step1_desc: "Voye montan an ba nou nan kont Zelle nou an ak referans ki bay la.",
    how_step2_title: "Nou trete",
    how_step2_desc: "Ekip nou an bay yon ajan lokal responsablite livrezon an.",
    how_step3_title: "Kliyan resevwa",
    how_step3_desc: "Ajan an livre lajan an bay reseptè a, epi ou resevwa notifikasyon.",
    cta_agent_title: "Ou se yon ajan? Konekte kounye a.",
    cta_agent_sub: "Aksede dashboard ou a ak nimewo telefòn ou pou wè transfè yo epi konfime livrezon.",
    cta_agent_btn: "Espas Ajan",
    footer_copy: "© {{year}} Takara Global Services",
    footer_tagline: "Fè ak ❤ pou dyaspora ayisyen an",
    logo_alt: "Logo TGS",
  },
  en: {
    welcome: "Welcome",
    agent_area_sub: "Takara Global Services — Agent portal",
    admin_area_sub: "See all TGS activity",
    app_name: "Takara Global Services",
    app_tag: "Zelle Transfer Management",
    tracking: "Track Transfer",
    admin: "Admin",
    agent: "Agent",
    login: "Sign in",
    logout: "Sign out",
    dashboard: "Dashboard",
    agents: "Agents",
    transfers: "Transfers",
    withdrawals: "Withdrawals",
    settings: "Settings",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    confirm: "Confirm",
    search: "Search...",
    loading: "Loading...",
    track_title: "Track Your Zelle Transfer",
    track_subtitle: "Enter your transfer No. (format TG12345678) to see the status",
    track_placeholder: "TG12345678",
    track_btn: "Check Status",
    track_not_found: "Transfer not found",
    status_pending: "Pending",
    status_processing: "Processing",
    status_delivered: "Delivered",
    status_canceled: "Canceled",
    admin_login_title: "Admin Sign In",
    email: "Email",
    password: "Password",
    total_agents: "Total Agents",
    total_transfers: "Total Transfers",
    delivered: "Delivered",
    pending: "Pending",
    total_amount: "Total Amount",
    system_profit: "System Profit",
    agent_profit_owed: "Agents Profit",
    pending_withdrawals: "Pending Withdrawals",
    completed_withdrawals: "Completed Withdrawals",
    activity_7d: "Activity last 7 days",
    add_agent: "Add Agent",
    name: "Name",
    phone: "Phone",
    address: "Address",
    cin: "CIN",
    nif: "NIF",
    telegram_chat_id: "Telegram Chat ID",
    profit: "Profit",
    percent: "Percent (%)",
    fixed: "Fixed ($)",
    withdrawal_method: "Withdrawal Method",
    active: "Active",
    inactive: "Inactive",
    new_transfer: "New Transfer",
    client_name: "Client Name",
    client_phone: "Client Phone",
    amount: "Amount",
    reference: "Reference",
    notes: "Notes",
    assign_to_agent: "Assign to Agent",
    agent_login_title: "Agent Portal",
    agent_login_sub: "Enter your phone number to access",
    process_delivery: "Process Delivery",
    confirm_delivery: "Confirm Delivery",
    cin_or_nif: "Beneficiary CIN or NIF",
    cin_or_nif_hint: "One field — CIN or NIF.",
    search_transfer_ph: "Search by Transfer No# (e.g. TG12345678)…",
    tap_row_to_treat: "Tap a row to process delivery — no need to scroll sideways.",
    no_transfer_match: "No transfers match your search",
    id_photo_required: "Required — beneficiary ID photo (JPG/PNG).",
    profit_total: "Total Profit",
    profit_withdrawn: "Withdrawn",
    profit_remaining: "Remaining",
    request_withdrawal: "Request Withdrawal",
    zelle_info: "Zelle Information",
    zelle_info_sub: "Name + Zelle phone number or email. WhatsApp is for on-site help.",
    zelle_account_name: "Name",
    zelle_handle: "Zelle phone or email",
    zelle_handle_ph: "e.g. +1305… or email@zelle.com",
    zelle_handle_hint: "Enter only one: the Zelle phone number, or the Zelle email.",
    account_name: "Account Name",
    account_email: "Account Email",
    account_phone: "Account Phone",
    zelle_whatsapp: "Support WhatsApp",
    zelle_whatsapp_hint: "Number for the WhatsApp help button on the site (e.g. +509…).",
    wa_assist: "WhatsApp Help",
    wa_assist_message: "Hello, I need help with a Takara Global Services (TGS) transfer.",
    forgot_password: "Forgot password?",
    forgot_password_title: "Recover password",
    forgot_password_sub: "Enter your admin email — we will send a reset link.",
    forgot_password_send: "Send link",
    reset_password_title: "New password",
    reset_password_sub: "Choose a new password (at least 8 characters).",
    new_password: "New password",
    confirm_password: "Confirm password",
    save_password: "Save password",
    change_password_title: "Admin password",
    change_password_sub: "Password is stored in MongoDB — deploys do not reset it.",
    current_password: "Current password",
    back_to_login: "Back to login",
    instructions: "Instructions",
    approve: "Approve",
    reject: "Reject",
    mark_paid: "Mark Paid",
    natcash_number: "NatCash Number",
    natcash_name: "Name on NatCash",
    welcome: "Welcome",
    agent_area_sub: "Takara Global Services agent portal",
    admin_area_sub: "View all Takara Global Services activity",
    service_fee: "Service Fee (%)",
    telegram_bot_token: "Telegram Bot Token",
    fund_agent: "Fund Agent",
    add_funding: "Add Funds",
    funding_amount: "Funding Amount",
    funding_history: "Funding History",
    total_funded: "Total Received",
    cash_delivered: "Cash Delivered",
    cash_in_hand: "Balance",
    no_funding: "No funds given yet",
    funding_note: "Note (optional)",
    // Home / landing
    hero_badge: "Zelle · Secure · Fast",
    hero_title: "Send money with {{brand}} — stress-free.",
    hero_subtitle: "Takara Global Services connects the Haitian diaspora with families in Haiti — reliable Zelle transfers delivered in minutes through our local agent network.",
    track_example: "Example:",
    trust_same_day: "Same-day confirmation",
    trust_secure: "100% Secure",
    trust_network: "Nationwide network",
    stat_delivery: "Delivery",
    stat_flat_fee: "Flat fee",
    stat_local: "Local",
    result_transfer_id: "Transfer No.",
    result_created_at: "Created on",
    result_delivered_at: "Delivered on",
    result_cancel_reason: "Cancellation reason",
    result_cancel_solution: "Next step",
    cancel_solution_refund: "We are preparing a refund. TGS will contact you on WhatsApp if more details are needed.",
    cancel_solution_reactivate: "The transfer will be reactivated. The beneficiary can pick up cash once the issue is resolved.",
    result_reactivated: "Reactivated",
    family_badge: "Happy Family",
    family_title: "Every dollar that arrives is a smile.",
    family_subtitle: "The money you send reaches your family directly — safely, reliably, and with peace of mind.",
    family_img_alt: "Happy family holding US dollars",
    why_eyebrow: "Why TGS",
    why_title: "One platform. Everything you need.",
    feat_fast_title: "Ultra fast",
    feat_fast_desc: "Confirmation within minutes after the recipient receives the money.",
    feat_secure_title: "Secure",
    feat_secure_desc: "Bank-grade infrastructure and tokenization to protect your information.",
    feat_agents_title: "Agent network",
    feat_agents_desc: "Trusted, well-trained local agents across the country.",
    feat_realtime_title: "Real-time reports",
    feat_realtime_desc: "Track every transaction — all the info on one page.",
    how_eyebrow: "How it works",
    how_title: "Just 3 simple steps",
    how_step1_title: "Send Zelle",
    how_step1_desc: "Send the amount to our Zelle account with the given reference.",
    how_step2_title: "We process",
    how_step2_desc: "Our team assigns a local agent for the delivery.",
    how_step3_title: "Client receives",
    how_step3_desc: "The agent delivers the cash to the recipient, and you get a notification.",
    cta_agent_title: "Are you an agent? Sign in now.",
    cta_agent_sub: "Access your dashboard with your phone number to view transfers and confirm deliveries.",
    cta_agent_btn: "Agent portal",
    footer_copy: "© {{year}} Takara Global Services",
    footer_tagline: "Made with ❤ for the Haitian diaspora",
    logo_alt: "TGS logo",
  },
  fr: {
    welcome: "Bienvenue",
    agent_area_sub: "Takara Global Services — Espace agent",
    admin_area_sub: "Voir toute l'activité TGS",
    app_name: "Takara Global Services",
    app_tag: "Gestion des Transferts Zelle",
    tracking: "Suivre Transfert",
    admin: "Admin",
    agent: "Agent",
    login: "Connexion",
    logout: "Déconnexion",
    dashboard: "Tableau de bord",
    agents: "Agents",
    transfers: "Transferts",
    withdrawals: "Retraits",
    settings: "Paramètres",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    confirm: "Confirmer",
    search: "Rechercher...",
    loading: "Chargement...",
    track_title: "Suivez Votre Transfert Zelle",
    track_subtitle: "Entrez votre Nº de transfert (format TG12345678) pour voir le statut",
    track_placeholder: "TG12345678",
    track_btn: "Vérifier",
    track_not_found: "Transfert introuvable",
    status_pending: "En attente",
    status_processing: "En cours",
    status_delivered: "Livré",
    status_canceled: "Annulé",
    admin_login_title: "Connexion Admin",
    email: "E-mail",
    password: "Mot de passe",
    total_agents: "Total Agents",
    total_transfers: "Total Transferts",
    delivered: "Livrés",
    pending: "En attente",
    total_amount: "Montant Total",
    system_profit: "Profit Système",
    agent_profit_owed: "Profits Agents",
    pending_withdrawals: "Retraits en attente",
    completed_withdrawals: "Retraits complétés",
    activity_7d: "Activité des 7 derniers jours",
    add_agent: "Ajouter Agent",
    name: "Nom",
    phone: "Téléphone",
    address: "Adresse",
    cin: "CIN",
    nif: "NIF",
    telegram_chat_id: "Telegram Chat ID",
    profit: "Profit",
    percent: "Pourcentage (%)",
    fixed: "Fixe ($)",
    withdrawal_method: "Méthode de retrait",
    active: "Actif",
    inactive: "Inactif",
    new_transfer: "Nouveau Transfert",
    client_name: "Nom Client",
    client_phone: "Téléphone Client",
    amount: "Montant",
    reference: "Référence",
    notes: "Notes",
    assign_to_agent: "Assigner à un agent",
    agent_login_title: "Espace Agent",
    agent_login_sub: "Entrez votre numéro de téléphone",
    process_delivery: "Traiter Livraison",
    confirm_delivery: "Confirmer Livraison",
    cin_or_nif: "CIN ou NIF du bénéficiaire",
    cin_or_nif_hint: "Un seul champ — CIN ou NIF.",
    search_transfer_ph: "Rechercher par No# Transfert (ex. TG12345678)…",
    tap_row_to_treat: "Appuyez sur une ligne pour traiter — pas besoin de glisser.",
    no_transfer_match: "Aucun transfert ne correspond à la recherche",
    id_photo_required: "Obligatoire — photo CIN/NIF du bénéficiaire (JPG/PNG).",
    profit_total: "Profit Total",
    profit_withdrawn: "Retiré",
    profit_remaining: "Restant",
    request_withdrawal: "Demander un retrait",
    zelle_info: "Informations Zelle",
    zelle_info_sub: "Nom + numéro ou email Zelle. WhatsApp sert à l'aide sur le site.",
    zelle_account_name: "Nom",
    zelle_handle: "Numéro ou email Zelle",
    zelle_handle_ph: "ex. +1305… ou email@zelle.com",
    zelle_handle_hint: "Entrez un seul: le numéro Zelle, ou l'email Zelle.",
    account_name: "Nom du compte",
    account_email: "E-mail du compte",
    account_phone: "Téléphone du compte",
    zelle_whatsapp: "WhatsApp assistance",
    zelle_whatsapp_hint: "Numéro pour le bouton d'aide WhatsApp sur le site (ex. +509…).",
    wa_assist: "Assistance WhatsApp",
    wa_assist_message: "Bonjour, j'ai besoin d'aide pour un transfert Takara Global Services (TGS).",
    forgot_password: "Mot de passe oublié ?",
    forgot_password_title: "Récupérer le mot de passe",
    forgot_password_sub: "Entrez l'email admin — nous enverrons un lien de réinitialisation.",
    forgot_password_send: "Envoyer le lien",
    reset_password_title: "Nouveau mot de passe",
    reset_password_sub: "Choisissez un nouveau mot de passe (au moins 8 caractères).",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    save_password: "Enregistrer",
    change_password_title: "Mot de passe admin",
    change_password_sub: "Le mot de passe est stocké dans MongoDB — les déploiements ne le réinitialisent pas.",
    current_password: "Mot de passe actuel",
    back_to_login: "Retour à la connexion",
    instructions: "Instructions",
    approve: "Approuver",
    reject: "Rejeter",
    mark_paid: "Marquer Payé",
    natcash_number: "Numéro NatCash",
    natcash_name: "Nom sur NatCash",
    welcome: "Bienvenue",
    agent_area_sub: "Espace agent Takara Global Services",
    admin_area_sub: "Voir toutes les activités de Takara Global Services",
    service_fee: "Frais de service (%)",
    telegram_bot_token: "Telegram Bot Token",
    fund_agent: "Financer l'agent",
    add_funding: "Ajouter des fonds",
    funding_amount: "Montant du financement",
    funding_history: "Historique des fonds",
    total_funded: "Total reçu",
    cash_delivered: "Espèces livrées",
    cash_in_hand: "Solde",
    no_funding: "Aucun fonds accordé",
    funding_note: "Note (optionnel)",
    // Home / landing
    hero_badge: "Zelle · Sécurisé · Rapide",
    hero_title: "Envoyez de l'argent via {{brand}} sans souci.",
    hero_subtitle: "Takara Global Services relie la diaspora haïtienne aux familles en Haïti — des transferts Zelle fiables livrés en quelques minutes via notre réseau d'agents locaux.",
    track_example: "Exemple :",
    trust_same_day: "Confirmation le jour même",
    trust_secure: "100 % sécurisé",
    trust_network: "Réseau national",
    stat_delivery: "Livraison",
    stat_flat_fee: "Frais fixes",
    stat_local: "Local",
    result_transfer_id: "Nº de transfert",
    result_created_at: "Date de création",
    result_delivered_at: "Livré le",
    result_cancel_reason: "Motif d'annulation",
    result_cancel_solution: "Solution",
    cancel_solution_refund: "Nous préparons un remboursement. TGS vous contactera sur WhatsApp si besoin.",
    cancel_solution_reactivate: "Le transfert sera réactivé. Le bénéficiaire pourra retirer l'argent une fois le problème résolu.",
    result_reactivated: "Réactivé",
    family_badge: "Famille heureuse",
    family_title: "Chaque dollar qui arrive est un sourire.",
    family_subtitle: "L'argent que vous envoyez arrive directement entre les mains de votre famille — en sécurité, de façon fiable, et en toute tranquillité.",
    family_img_alt: "Famille heureuse tenant des dollars américains",
    why_eyebrow: "Pourquoi TGS",
    why_title: "Une seule plateforme. Tout ce dont vous avez besoin.",
    feat_fast_title: "Ultra rapide",
    feat_fast_desc: "Confirmation en quelques minutes après réception par le bénéficiaire.",
    feat_secure_title: "Sécurisé",
    feat_secure_desc: "Infrastructure de niveau bancaire et tokenisation pour protéger vos informations.",
    feat_agents_title: "Réseau d'agents",
    feat_agents_desc: "Des agents locaux de confiance, bien formés, partout dans le pays.",
    feat_realtime_title: "Rapports en temps réel",
    feat_realtime_desc: "Suivez toutes vos transactions — toutes les infos sur une seule page.",
    how_eyebrow: "Comment ça marche",
    how_title: "Seulement 3 étapes simples",
    how_step1_title: "Envoyer Zelle",
    how_step1_desc: "Envoyez le montant sur notre compte Zelle avec la référence fournie.",
    how_step2_title: "Nous traitons",
    how_step2_desc: "Notre équipe confie la livraison à un agent local.",
    how_step3_title: "Le client reçoit",
    how_step3_desc: "L'agent remet l'argent au bénéficiaire, et vous recevez une notification.",
    cta_agent_title: "Vous êtes agent ? Connectez-vous maintenant.",
    cta_agent_sub: "Accédez à votre tableau de bord avec votre numéro de téléphone pour voir les transferts et confirmer les livraisons.",
    cta_agent_btn: "Espace agent",
    footer_copy: "© {{year}} Takara Global Services",
    footer_tagline: "Fait avec ❤ pour la diaspora haïtienne",
    logo_alt: "Logo TGS",
  },
};
